import React from 'react';

function ShiftToggle({ shift, onChange }) {
  return (
    <div className="shift-toggle no-print">
      <button
        className={`shift-btn ${shift === 'day' ? 'active' : ''}`}
        onClick={() => onChange('day')}
        title="Дневная смена"
      >
        ☀️ День
      </button>
      <button
        className={`shift-btn ${shift === 'night' ? 'active' : ''}`}
        onClick={() => onChange('night')}
        title="Ночная смена"
      >
        🌙 Ночь
      </button>
    </div>
  );
}

export default ShiftToggle;